module.exports = __webpack_public_path__ + "img/setting.21e652b3.svg";